// @flow

import React from 'react';
import AccountDetails  from '../../components/AccountDetails'

import './style.css';

function UserProfile() {    
    React.useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        <AccountDetails />
    );
}

export default UserProfile;
